import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import militaryLoaderHero from '@/assets/landing-activity-male/military-loader-hero-2x.webp'

const schema: LandingScreenSchema = {
	config: {
		background: 'transparent',
	},

	order: [
		'LandingBackgroundImage',
		'LandingHead',
		'LandingTitle',
		'LandingComponentSpacer',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingBackgroundImage: (): LandingComponentsConfig['LandingBackgroundImage'] => ({
			image: militaryLoaderHero,
			// Anchor to top so the subject's face isn't cropped on short/wide viewports.
			position: 'top',
		}),

		LandingHead: (): LandingComponentsConfig['LandingHead'] => ({
			logoAlignment: 'center',
			logoColor: 'white',
		}),

		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('military_calisthenics.pages.landing.loader.title_m'),
			size: 'medium',
			customStyles: {
				color: 'var(--Text-Primary-White, #ffffff)',
				textAlign: 'center',
				marginLeft: '1.5rem',
				marginRight: '1.5rem',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
			theme: 'white',
		}),
		LandingFooter: (): LandingComponentsConfig['LandingFooter'] => ({
			textColor: 'white',
		}),
	},
}

export default schema
